// @flow

// TODO build out complete list of products
export const ProductNames = Object.freeze({
  corporatecard: 'corporatecard',
  gateddocs: 'gateddocs',
  implementationguides: 'implementationguides',
  styleguide: 'styleguide',
  capital: 'capital',
  revrec: 'revrec',
  subscriptions: 'subscriptions',
  paymentlinks: 'paymentlinks',
  banking: 'banking',
});

type ProductMeta = {
  overviewPageRoute: string,
  displayName: string,
};

type ProductsMapType = $Exact<{
  [key: $Values<typeof ProductNames>]: ProductMeta,
}>;

export const Products: ProductsMapType = {
  [ProductNames.corporatecard]: {
    overviewPageRoute: 'corporate-card',
    displayName: 'Corporate card',
  },
  [ProductNames.gateddocs]: {
    overviewPageRoute: 'gated-docs',
    displayName: 'Gated docs',
  },
  [ProductNames.implementationguides]: {
    overviewPageRoute: 'implementation-guides',
    displayName: 'Implementation guides',
  },
  [ProductNames.styleguide]: {
    overviewPageRoute: 'style-guide',
    displayName: 'Style guide',
  },
  [ProductNames.capital]: {
    overviewPageRoute: 'capital/faqs',
    displayName: 'Capital',
  },
  [ProductNames.revrec]: {
    overviewPageRoute: 'billing/revenue-recognition',
    displayName: 'Revenue recognition',
  },
  [ProductNames.subscriptions]: {
    overviewPageRoute: 'billing',
    displayName: 'Billing',
  },
  [ProductNames.paymentlinks]: {
    overviewPageRoute: 'payments/payment-links',
    displayName: 'Payment Links',
  },
  [ProductNames.banking]: {
    overviewPageRoute: 'treasury',
    displayName: 'Banking',
  },
};

export const getProductOverviewPageRoute = (productName: string): string => {
  const route = ProductNames[productName]
    ? Products[ProductNames[productName]].overviewPageRoute
    : productName;
  return `/docs/${route}`;
};

export const getProductDisplayName = (productName: string): string => {
  return ProductNames[productName]
    ? Products[ProductNames[productName]].displayName
    : productName;
};
